import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContadorGraficoDirective } from './contador-grafico.directive';
import { ImagePreloadDirective } from './image-preload.directive';
import { MaskDateDirective } from './mask-date-directive';
import { MustMatchDirective } from './must-match.directive';
import { TabDirective } from './tab.directive';
import { ValorMinimoDirective } from '../validadores/valor-minimo.directive';
import { ValidaCpfCNPJDirective, ValidaCpfDirective } from '../validadores/valida-cpf.directive';
import { ValidaInscricaoEstadualDirective } from '../validadores/valida-inscricao-estadual.directive';
import { ButtonAnalyticsEventTrackerDirective } from './button-analytics-event-tracker.directive';
import { DndAnexoUploaderDirective } from './dnd-anexo-uploader.directive';


@NgModule({
  declarations: [
    ContadorGraficoDirective,
    ImagePreloadDirective,
    MaskDateDirective,
    MustMatchDirective,
    TabDirective,
    ValorMinimoDirective,
    ValidaCpfCNPJDirective,
    ValidaCpfDirective,
    ValidaInscricaoEstadualDirective,
    ButtonAnalyticsEventTrackerDirective,
    DndAnexoUploaderDirective
  ],
  exports: [
    ContadorGraficoDirective,
    ImagePreloadDirective,
    MaskDateDirective,
    MustMatchDirective,
    TabDirective,
    ValorMinimoDirective,
    ValidaCpfCNPJDirective,
    ValidaCpfDirective,
    ValidaInscricaoEstadualDirective,
    DndAnexoUploaderDirective
  ],
  imports: [
    CommonModule
  ]
})
export class DirectivesModule { }
